import dayIsNowDayBefore from './dayIsNowDayBefore';
import dayIsSameDay from './dayIsSameDay';
import dayIsNowDayAfter from './dayIsNowDayAfter';
import sortAndCombineDayOfTimeblocks from './sortAndCombineDayOfTimeblocks';
import buildSbmParams from './buildSbmParams';
import getCynoMidnightTime from './getCynoMidnightTime';

const sortAvailabilityTimesInCynoTimeByCynoDays = (availabilityTimeBlockInCynoTime, day, operationType, availabilityDaysInCynoTime, SBMId) => {
    let sbmParamsObjectSet = {};
    let sbmParamsObjectTemplate = {
        "start_time": "",
        "end_time": "",
        "is_day_off": 1,
        "breaktime": [{}],
        "index": "",
        "name": "",
        "date": "",
        "unit_group_id": SBMId.toString(),
        "event_id": "",
    };
    availabilityTimeBlockInCynoTime.map((dayOfBlocks, i) => {
        // 'i' tells us that time zone conversion has moved timeBlocks to a past day/date(0) or a future day/date(2)
        if (dayOfBlocks.length > 0) {
            if (dayIsNowDayBefore(i)) {
                const pastDay = (parseInt(day, 10) - 1).toString();
                const adjustedPastDaySBMIndex = pastDay === '0' ? '7' : pastDay;

                if (typeof availabilityDaysInCynoTime[pastDay][0] === 'string') {
                    availabilityDaysInCynoTime[pastDay] = [...dayOfBlocks];
                }
                else {
                    availabilityDaysInCynoTime[pastDay].push(...dayOfBlocks);
                };

                const combinedDay = sortAndCombineDayOfTimeblocks(availabilityDaysInCynoTime[pastDay]);
                availabilityDaysInCynoTime[pastDay] = combinedDay;
                const sbmParamsObject = buildSbmParams(combinedDay, adjustedPastDaySBMIndex, operationType, SBMId);
                sbmParamsObjectSet[adjustedPastDaySBMIndex] = sbmParamsObject;
            }
            if (dayIsSameDay(i)) {
                const adjustedDaySBMIndex = day === '7' ? '0' : day;
                let nextDay;
                if (day === '6') {
                    nextDay = '0';
                } else if (day === '7') {
                    nextDay = '1';
                } else {
                    nextDay = (parseInt(day, 10) + 1).toString();
                }

                if (typeof availabilityDaysInCynoTime[adjustedDaySBMIndex][0] === 'string') {
                    availabilityDaysInCynoTime[adjustedDaySBMIndex] = [...dayOfBlocks];
                }
                else {
                    availabilityDaysInCynoTime[adjustedDaySBMIndex].push(...dayOfBlocks);
                };

                const nextDaysTimeBlocksToSave = availabilityTimeBlockInCynoTime[2];
                let nextDaysExistingAvailability = availabilityDaysInCynoTime[nextDay];
                // THIS COMPARES WHAT WE ARE SAVING AND CURRENT AVAILABILITY ON THE NEXT DAY - THIS CHECK ENSURES THAT TIMES AFFECTING THE NEXT DAY AFTER TIMEZONE CONVERSION GETS UPDATED/DELETED CORRECTLY
                if (!nextDaysTimeBlocksToSave.length && typeof nextDaysExistingAvailability[0] !== 'string') {
                    const adjustedNextDaySBMIndex = (day === '7') ? '1' : (parseInt(day, 10) + 1).toString();
                    const cynoMidnightTime = getCynoMidnightTime();
                    const nextDayFirstBlockStart = availabilityDaysInCynoTime[nextDay][0][0].replace(":",'.');
                    const nextDayFirstBlockEnd = availabilityDaysInCynoTime[nextDay][0][1].replace(":",'.');
                    if (nextDayFirstBlockStart < cynoMidnightTime && nextDayFirstBlockEnd <= cynoMidnightTime) {
                        availabilityDaysInCynoTime[nextDay].shift();
                        let nextDaySbmParamsObject;
                        if (availabilityDaysInCynoTime[nextDay].length) {
                            nextDaySbmParamsObject = buildSbmParams(availabilityDaysInCynoTime[nextDay], adjustedNextDaySBMIndex, operationType, SBMId);
                        } else {
                            availabilityDaysInCynoTime[nextDay][0] = "";
                            nextDaySbmParamsObject = sbmParamsObjectTemplate;
                            nextDaySbmParamsObject["index"] = adjustedNextDaySBMIndex.toString();
                        }
                        sbmParamsObjectSet[adjustedNextDaySBMIndex] = nextDaySbmParamsObject;
                    } else if (nextDayFirstBlockStart < cynoMidnightTime && nextDayFirstBlockEnd > cynoMidnightTime) {
                        availabilityDaysInCynoTime[nextDay][0][0] = cynoMidnightTime.replace(".",':');
                        const nextDaySbmParamsObject = buildSbmParams(availabilityDaysInCynoTime[nextDay], adjustedNextDaySBMIndex, operationType, SBMId);
                        sbmParamsObjectSet[adjustedNextDaySBMIndex] = nextDaySbmParamsObject;
                    }
                }
                const combinedDay = sortAndCombineDayOfTimeblocks(availabilityDaysInCynoTime[adjustedDaySBMIndex]);
                availabilityDaysInCynoTime[adjustedDaySBMIndex] = combinedDay;
                const sbmParamsObject = buildSbmParams(combinedDay, day, operationType, SBMId);
                sbmParamsObjectSet[day] = sbmParamsObject;
            }
            if (dayIsNowDayAfter(i)) {
                let nextDay;
                if (day === '6') {
                    nextDay = '0';
                } else if (day === '7') {
                    nextDay = '1';
                } else {
                    nextDay = (parseInt(day, 10) + 1).toString();
                }
                const adjustedNextDaySBMIndex = (day === '7') ? '1' : (parseInt(day, 10) + 1).toString();
                if (typeof availabilityDaysInCynoTime[nextDay][0] === 'string') {
                    availabilityDaysInCynoTime[nextDay] = [...dayOfBlocks];
                }
                else {
                    availabilityDaysInCynoTime[nextDay].push(...dayOfBlocks);
                };

                const combinedDay = sortAndCombineDayOfTimeblocks(availabilityDaysInCynoTime[nextDay]);
                availabilityDaysInCynoTime[nextDay] = combinedDay;
                const sbmParamsObject = buildSbmParams(combinedDay, adjustedNextDaySBMIndex, operationType, SBMId);
                sbmParamsObjectSet[adjustedNextDaySBMIndex] = sbmParamsObject;
            };
        };
    });
    return [sbmParamsObjectSet, availabilityDaysInCynoTime];
};

export default sortAvailabilityTimesInCynoTimeByCynoDays;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/utils/sortAvailabilityTimesInCynoTimeByCynoDays.js